/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React from "react";
import PrinterForm from "./PrinterForm";
import "./Printer.css";
import "../commons/Form.css";

const CreatePrinter = () => {
  return (<PrinterForm />);
};

export default CreatePrinter;